const B2C_EMAIL_PLACEHOLDER = 'unknown@placeholder.local';

function isUsableLoginEmail(raw: string | undefined): raw is string {
  const s = raw?.trim();
  if (!s) return false;
  if (s.toLowerCase() === B2C_EMAIL_PLACEHOLDER) return false;
  return true;
}

/**
 * Extracts email from B2C account when idTokenClaims lacks email/emails.
 * Federated OIDC flows often omit the OIDC `email` claim unless mapped; Entra emits `preferred_username` (UPN),
 * which B2C can map into `email` in policy. Falls back to idp_access_token payload when present.
 */
export function getEmailFromAccount(account: { username?: string; idTokenClaims?: Record<string, unknown> }): string | undefined {
  if (isUsableLoginEmail(account?.username)) {
    return account.username!.trim();
  }
  const claims = account?.idTokenClaims;
  if (!claims) return undefined;

  const fromDirect =
    (claims['email'] as string) ??
    (claims['preferred_username'] as string) ??
    (claims['upn'] as string) ??
    (claims['emails'] as string[])?.[0];
  if (isUsableLoginEmail(fromDirect)) {
    return fromDirect.trim();
  }

  const idpToken = claims['idp_access_token'] as string | undefined;
  if (!idpToken) return undefined;

  try {
    const payload = JSON.parse(atob(idpToken.split('.')[1]));
    const fromToken =
      (payload.preferred_username as string) ??
      (payload.upn as string) ??
      (payload.unique_name as string) ??
      (payload.email as string);
    return isUsableLoginEmail(fromToken) ? fromToken.trim() : undefined;
  } catch {
    return undefined;
  }
}
